import { withRouter } from "react-router-dom";
import { PrimaryButton } from "@graffer-inc/console-design-kit";
import { BrowserTemplate } from "../../../template/service-provider/default-template";

export const ServiceProviderLoginPage = withRouter(() => {
  return (
    <BrowserTemplate>
      <div className="has-text-centered">
        <section className="hero">
          <div className="hero-body">
            <h1 className="title">サービスプロバイダーアカウント 管理画面</h1>
            <a href={process.env.REACT_APP_ACCOUNT_OKTA_LOGIN}>
              <PrimaryButton text={"Okta でログインする"} />
            </a>
          </div>
        </section>
      </div>
    </BrowserTemplate>
  );
});
